<template>
  <div class="relative" v-click-outside="handleClose">
    <slot name="toggle" :toggle="handleToggle" />
    <div
      :class="[
        'absolute right-0 z-10 w-full min-w-fit divide-y divide-gray-100 overflow-y-auto rounded bg-white shadow',
        topClass ? 'top-12' : ''
      ]"
      :style="{ width: width, top: top, bottom }"
      :id="id"
    >
      <slot v-if="visible" name="content" :close="handleClose" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: null,
    },
    top: String,
    bottom: String,
    topClass: {
      type: Boolean,
      default: true
    },
    id: String
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleShow() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
    handleToggle() {
      this.visible = !this.visible;
    },
  },
};
</script>
